import { useEffect } from "react";

export function useSetTimeout(callback: () => void, ms: number) {
    useEffect(() => {
        const timer = setTimeout(callback, ms);
        return () => {
            clearTimeout(timer);
        };
    }, [callback, ms]);
}
